import { render, staticRenderFns } from "./ShippedPacking.vue?vue&type=template&id=a3c3f8ba&"
import script from "./ShippedPacking.vue?vue&type=script&lang=js&"
export * from "./ShippedPacking.vue?vue&type=script&lang=js&"
import style0 from "./ShippedPacking.vue?vue&type=style&index=0&id=a3c3f8ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports